"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPushpinChartDescriptor = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var PluggableGeoPushpinChart_1 = require("./PluggableGeoPushpinChart");
var constants_1 = require("../constants");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var embeddingCodeGenerator_1 = require("../../../utils/embeddingCodeGenerator");
var geoConfigCodeGenerator_1 = require("./geoConfigCodeGenerator");
var chartCodeGenUtils_1 = require("../chartCodeGenUtils");
var GeoPushpinChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(GeoPushpinChartDescriptor, _super);
    function GeoPushpinChartDescriptor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getEmbeddingCode = embeddingCodeGenerator_1.getReactEmbeddingCodeGenerator({
            component: {
                importType: "named",
                name: "GeoPushpinChart",
                package: "@gooddata/sdk-ui-geo",
            },
            insightToProps: embeddingCodeGenerator_1.getInsightToPropsConverter({
                location: geoConfigCodeGenerator_1.geoInsightConversion("location", sdk_ui_1.BucketNames.LOCATION),
                latitude: geoConfigCodeGenerator_1.geoInsightConversion("latitude", sdk_ui_1.BucketNames.LATITUDE),
                longitude: geoConfigCodeGenerator_1.geoInsightConversion("longitude", sdk_ui_1.BucketNames.LONGITUDE),
                size: embeddingCodeGenerator_1.singleAttributeOrMeasureBucketConversion("size", sdk_ui_1.BucketNames.SIZE),
                color: embeddingCodeGenerator_1.singleAttributeOrMeasureBucketConversion("color", sdk_ui_1.BucketNames.COLOR),
                segmentBy: embeddingCodeGenerator_1.singleAttributeBucketConversion("segmentBy", sdk_ui_1.BucketNames.SEGMENT),
                filters: embeddingCodeGenerator_1.filtersInsightConversion("filters"),
                sortBy: embeddingCodeGenerator_1.sortsInsightConversion("sortBy"),
                config: embeddingCodeGenerator_1.insightConversion("config", {
                    typeImport: {
                        importType: "named",
                        name: "IGeoConfig",
                        package: "@gooddata/sdk-ui-geo",
                    },
                    cardinality: "scalar",
                }, geoConfigCodeGenerator_1.geoConfigFromInsight),
                locale: embeddingCodeGenerator_1.localeInsightConversion("locale"),
                execConfig: embeddingCodeGenerator_1.executionConfigInsightConversion("execConfig"),
            }),
            additionalFactories: chartCodeGenUtils_1.chartAdditionalFactories({
                getColorMappingPredicatePackage: "@gooddata/sdk-ui-geo",
            }),
        });
        return _this;
    }
    GeoPushpinChartDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableGeoPushpinChart_1.PluggableGeoPushpinChart(params); };
    };
    GeoPushpinChartDescriptor.prototype.getSizeInfo = function (_insight, layoutDescriptor, settings) {
        return {
            width: {
                default: 6,
                min: 6,
                max: layoutDescriptor.gridColumnsCount,
            },
            height: {
                default: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                min: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                max: this.getMaxHeight(settings.enableKDWidgetCustomHeight),
            },
        };
    };
    GeoPushpinChartDescriptor.prototype.getMeta = function () {
        return {
            documentationUrl: "https://sdk.gooddata.com/gooddata-ui/docs/geo_pushpin_chart_component.html",
            supportsExport: true,
            supportsZooming: false,
        };
    };
    GeoPushpinChartDescriptor.prototype.getMinHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT;
        }
        return constants_1.MIDDLE_VISUALIZATION_HEIGHT;
    };
    return GeoPushpinChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.GeoPushpinChartDescriptor = GeoPushpinChartDescriptor;
//# sourceMappingURL=GeoPushpinChartDescriptor.js.map